<i18n>
{
"en": {
  "DIRECTIONS": "Directions",
  "HOMETOSCHOOL": "Home to School",
  "SCHOOLTOHOME": "School to Home",
  "MINUTES": "Minutes",
  "BUSTRIPS": "Bus Trips",
  "LOADING": "Loading...",
  "LIST": "List",
  "MAP": "Map",
  "SELECTROUTE": "Select Route",
  "UNCHECKALL": "Uncheck All",
  "CHECKALL": "Check All",
  "CHOOSEFILTERBY": "Choose Filter By",
  "FILTERBYDIRECTION": "Filter by direction",
  "FILTERBYMONITOR": "Filter by monitor",
  "PICKARANGE": "Pick a range",
  "CLOSEDTRIPS": "Closed Trips",
  "LIVETRIPS": "Live Trips",
  "NODATA": "No Data",
  "TRIPCLOSED": "Trip Closed",
  "DIRECTION": "Direction",
  "SUPERVISOR": "Supervisor",
  "DATE": "Date",
  "FIRSTSTOP": "First Stop",
  "SCHOOL": "School",
  "NEXTSTOP": "Next Stop",
  "LASTSTOP": "Last Stop",
  "NOMORESTOPS": "No More Stops",
  "CHILDBEHAVIOUR": "Child Behaviour",
  "MEDICAL": "Medical",
  "DRIVERISSUE": "Driver Issue",
  "BUSPROBLEM": "Bus Problem",
  "ACCIDENT": "Accident",
  "TRAFFIC": "Traffic",
  "CALLPOLICE": "Call Police",
  "CALLSCHOOL": "Call School",
  "OTHER": "Other",
  "STARTEDAT": "Started at",
  "CLOSEDAT": "Closed at",
  "NOTCLOSINGYET": "Not closing yet",
  "EXPECTEDTOSTART": "Expected To Start..",
  "DELAYED": "Delayed",
  "DURATION": "Duration",
  "STANDING": "Standing",
  "MISSED": "Missed",
  "WRONGPLACE": "Wrong Place",
  "NOVIOLATIONS": "No Violations",
  "TRIPVIOLATIONS": "Trip Violations",
  "TRIPALERTS": "Trip Alerts",
  "NOALERTS": "No Alerts",
  "OCCURED": "Occured",
  "TYPE": "Type",
  "MESSAGE": "Message",
  "MOREINFO": "More Info",
  "DELAYEDBY": "Delayed by:",
  "HOUR": "hour | hours",
  "MINUTE": "minute | minutes",
  "ALERT": "Alert",
  "INCIDENT": "Incident",
  "VIEWALERTS": "View Alerts",
  "VIEWINCIDENTS": "View Incidents",
  "VIEWVIOLATIONS": "View Violations",
  "NOANYCLEANTRIPS": "No clear trips",
  "NOANYWARNTRIPS": "No flagged trips",
  "FUELCOST": "Fuel cost is",
  "TOTALCOST": "Total cost is",
  "IDLECOST": "Idle cost is",
  "AED": "AED"
},
"ar": {
  "DIRECTIONS": "الاتجاهات",
  "HOMETOSCHOOL": "من البيت الى المدرسة",
  "SCHOOLTOHOME": "من المدرسة الى البيت",
  "MINUTES": "دقائق",
  "BUSTRIPS": "الرحلات",
  "LOADING": "جار التحميل...",
  "LIST": "قائمة",
  "MAP": "خريطة",
  "SELECTROUTE": "حدد الطريق",
  "UNCHECKALL": "الغاءالكل",
  "CHECKALL": "تحقق من الكل",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "FILTERBYDIRECTION": "تصفية حسب الاتجاه",
  "FILTERBYMONITOR": "تصفية حسب المشرفة",
  "PICKARANGE": " اختيار مجموعة",
  "CLOSEDTRIPS": "رحلات مغلقة",
  "LIVETRIPS": "رحلات على المباشر",
  "NODATA": "لايوجد بيانات",
  "TRIPCLOSED": "أغلقت الرحلة",
  "DIRECTION": "اتجاه",
  "SUPERVISOR": "المشرفة",
  "DATE": "تاريخ",
  "FIRSTSTOP": "المحطة الأولى",
  "SCHOOL": "المدرسة",
  "NEXTSTOP": " المحطة التالية",
  "LASTSTOP": " المحطة الأخيرة",
  "NOMORESTOPS": "لا مزيد من توقف",
  "CHILDBEHAVIOUR": "سلوك الطفل",
  "MEDICAL": " طبي",
  "DRIVERISSUE": "مشكلة السائق",
  "BUSPROBLEM": "مشكلة الحافلة",
  "ACCIDENT": "حادث",
  "TRAFFIC": "حركة المرور",
  "CALLPOLICE": "اتصل بالشرطة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "OTHER": "آخر",
  "STARTEDAT": "بدأت في",
  "CLOSEDAT": "مغلق في",
  "NOTCLOSINGYET": "لم يتم الإغلاق بعد",
  "EXPECTEDTOSTART": "...من المتوقع البدء ",
  "DELAYED": "مؤجل",
  "DURATION": "المدة الزمنية",
  "STANDING": "واقفا",
  "MISSED": "مفقود",
  "WRONGPLACE": "المكان الخطأ",
  "NOVIOLATIONS": "لا توجد انتهاكات",
  "TRIPVIOLATIONS": "انتهاكات الرحلة",
  "TRIPALERTS": "تنبيهات الرحلة",
  "NOALERTS": "لا توجد تنبيهات",
  "EVENT": "حدث",
  "TYPE": "نوع",
  "MESSAGE": "رسالة",
  "MOREINFO": "معلومات اكثر",
  "DELAYEDBY": ":تأخر",
  "HOUR": "ساعة | ساعات",
  "MINUTE": "دقيقة | دقائق",
  "ALERT": "إنذار",
  "INCIDENT": "حادث",
  "VIEWVIOLATIONS": "عرض الانتهاكات",
  "NOANYCLEANTRIPS": "لا رحلات سلسة",
  "NOANYWARNTRIPS": "لا رحلات مع التنبيهات",
  "FUELCOST": "تكلفة السفر هو",
  "TOTALCOST": "تكلفة صيانة المركبات هي",
  "IDLECOST": "تكلفة الوقت الضائع",
  "AED": "درهم"
}
}
</i18n>
<template>
  <div id="trip">
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }" >
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('BUSTRIPS')}}</span>
      </div>      
      <div  v-loading="loading" :element-loading-text="$t('LOADING')">
        <el-row :gutter="20"  class="filters" ref="filter">
          <el-col :span="2">
            <el-button  style="width: 100%;" @click="tab=(tab==1 ? 0 : 1)">
              <i class="fa" v-bind:class="[tab===0 ? 'fa-list' : 'fa-map-marker']"></i>
              <span v-text="tab===0 ? $t('LIST') : $t('MAP')"></span>
            </el-button>
          </el-col>
          <el-col :span="4" v-if="tab===0">
            <el-select  v-if="active_trips()!=0" :disabled="loading" @change="routeChange" v-model="route" :placeholder="$t('SELECTROUTE')">
            <el-option  class="route-select" :value="-1"><el-tag  style="display:block; text-align:center;"  type="primary">{{selectAll() ? $t('UNCHECKALL') : $t('CHECKALL')}}</el-tag></el-option>
              <el-option
                v-if="isLive(item)"
                :key="key"
                v-for="(item, key) in routes"
                :label="item.TourName"
                :value="key">
                <el-tag style="display:block; text-align:center;"  v-bind:style="'background-color:' + item.RouteColor">
                {{ item.TourName }}
                <span style="float: right"><i v-show="paths[item.TourID] !=undefined" class="fa fa-check"></i></span> 
                </el-tag>
              </el-option>
               </el-select>
          </el-col>
          <el-col :span="4" v-if="tab==1 && !is_live">
            <el-select  v-model="filter" @change="changedFilter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

         
           </el-col>          
         <el-col :span="4"  v-if="tab==1 && !is_live && active_filter=='direction'">
             <el-select v-model="Direction" :placeholder="$t('FILTERBYDIRECTION')" @change="getFilteredTrips" clearable>
                <el-option value="1" :label="$t('HOMETOSCHOOL')"></el-option>
                <el-option value="2" :label="$t('SCHOOLTOHOME')"></el-option>
            </el-select>     
           </el-col>
         <el-col :span="4"  v-if="tab==1 && !is_live && active_filter=='monitor'">
             <el-select v-model="BusMonitorID" :placeholder="$t('FILTERBYMONITOR')" @change="getFilteredTrips" filterable clearable>
              <el-option
                :key="index" v-for="(item, index) in monitors"
                :label="item.FirstName_EN + ' ' + item.LastName_EN"
                :value="item.BusMonitorID">
              </el-option>
            </el-select>     
           </el-col>                    
         <el-col :span="4"  v-if="tab==1 && !is_live && active_filter=='date'">
              <el-date-picker
                v-model="date"
                type="daterange"
                @change="getFilteredTrips('date')"
                :placeholder="$t('PICKARANGE')"
                :picker-options="pickerOption"
                :clearabble="checkToday()">
              </el-date-picker>    
          </el-col>          
          <el-col :span="6" class="live-trip-btn">
          <el-badge :value="active_trips()"  v-if="tab===1">
            <el-button-group>
              <el-button :type="!is_live ? 'primary' : 'default'" @click="btnGroup(false)">{{$t('CLOSEDTRIPS')}}</el-button>
              <el-button :type="is_live ? 'primary' : 'default'"  @click="btnGroup(true)">{{$t('LIVETRIPS')}}</el-button>
            </el-button-group>
          </el-badge>
          </el-col>
        </el-row>     
        <el-row>
            <div id="live-gmap" v-show="tab==0"  style="width: 100%;" v-bind:style="{ height: mapHeight + 'px' }"></div>
            <div v-show="tab==1" style="border-top:1px solid #ddd" v-bind:style="{ height:  listHeight + 'px' }">
              <el-row  type="flex" style="height: inherit">
                <el-col :span="12" class="twocolumn">               
                  <div v-if="listTrips['left'].length == 0" class="el-table__empty-block" style="width: 100%">
                    <span class="el-table__empty-text">{{$t('NOANYWARNTRIPS')}}</span>
                  </div>                
                  <VuePerfectScrollbar  ref="ScrollbarLeft"  v-bind:style="{ height: listHeight + 'px' }">
                    <div>
                      <el-button v-if="is_live==!trip.IsClosed" :disabled="trip.disabledTrip" @click="goTo(trip.TripID)"  type="text"  class="trip-box" :key="key"  v-for="(trip,key) in listTrips['left']">
                      <el-row  v-if="cachedDates['left'][trip.Date]==trip.TripID" class="row date-header"><i class="el-icon-date"></i> {{tripDate(trip.Db_Date)}}</el-row >

                      <el-row style="padding:0 10px">
                        <el-col :span="2" class="busTag"><el-tag  type="primary"><i class="fa fa-bus"></i> {{trip.busNumber}} </el-tag></el-col>
                        <el-col :span="5" :align="alignDirection('right')" class="activity" @mouseover.native="trip.disabledTrip = true" @mouseleave.native="trip.disabledTrip = false">
                          <el-popover
                            popper-class="trip"
                            trigger="hover"
                            :disabled="trip.activity.total_alerts == 0"
                            :title="$t('TRIPALERTS')"
                            placement="right-start"
                            width="620"
                            >
                            <el-badge slot="reference" :value="trip.activity.total_alerts" :max="6"><el-button size="mini"><i class="fa fa-bell" aria-hidden="true"></i></el-button></el-badge>                   
                            <el-table 
                                :data="arrayOfAlerts(trip.activity.alerts)"
                                :default-sort="{prop: 'Sent', order: 'descending'}"
                                :empty-text="$t('NOALERTS')"
                                stripe
                                style="width: 100%"
                                >
                              <el-table-column width="85" :label="$t('TYPE')"><template slot-scope="scope">{{$t(scope.row.Event)}}</template></el-table-column>
                              <el-table-column width="130" :label="$t('OCCURED')">
                                <template slot-scope="scope">{{$t(scope.row.EventType)}}</template>
                              </el-table-column>
                              <el-table-column width="195" property="Sent" :label="$t('DATE')">
                                <template slot-scope="scope">
                                  <el-icon name="time"></el-icon>
                                  <span style="margin-left: 5px">{{ activity_time(scope.row.Sent) }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column show-overflow-tooltip :label="$t('MESSAGE')"><template slot-scope="scope">{{scope.row.Text ? scope.row.Text : '-'}}</template></el-table-column>
                              <el-table-column align="center" width="90"><template slot-scope="scope"><el-button v-if="scope.row.EntityID != null || scope.row.Event == 'INCIDENT'" size="mini" :loading="scope.row.EventID === sendingEvent" @click="activityInfo(scope.row, scope.$index)">{{$t('MOREINFO')}}</el-button></template></el-table-column>
                            </el-table>                  
                          </el-popover>
                          <el-popover
                            trigger="hover"
                            :disabled="trip.activity.total_violations == 0"
                            :title="$t('TRIPVIOLATIONS')"
                            placement="right"
                            width="450"
                            >
                            <el-badge slot="reference" :value="trip.activity.total_violations" :max="6"><el-button size="mini"><i class="fa fa-tachometer"></i></el-button></el-badge>
                            <el-table 
                                :data="arrayOfAlerts(trip.activity.violations)"
                                :empty-text="$t('NOVIOLATIONS')"
                                stripe
                                style="width: 100%"
                                >
                              <el-table-column label="Type" min-width="115">
                                <template slot-scope="scope">{{$t(scope.row.incident_type)}}</template>
                              </el-table-column>
                              <el-table-column min-width="185" label="Date">
                                <template slot-scope="scope">
                                  <el-icon name="time"></el-icon>
                                  <span style="margin-left: 5px">{{ activity_time(scope.row.Timestamp) }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column width="145" show-overflow-tooltip property="Text" label="Message"></el-table-column>
                            </el-table>                  
                          </el-popover>
                        </el-col>
                        <el-col :span="11" align="center"><i class="fa fa-road fa-2x"></i> {{trip.TourName}}</el-col>
                        <el-col :span="6" class="boardingTag">
                          <el-tag  type="primary"><i class="fa fa-user-circle"></i> <b  v-text="trip.Boarding"></b></el-tag>
                          <el-tag  type="primary" v-if="trip.IsClosed!=1"><i class="fa fa-map-marker"></i> {{nextStop(trip)}}</el-tag>
                          <el-tag  type="success" v-if="trip.IsClosed==1"><i class="fa fa-clock-o"></i> <b  v-text="trip.CompletedIn"></b> {{$t('MINUTES')}}</el-tag>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="2" align="center"><el-tooltip :disabled="trip.Db_Date == null" effect="light" :content="$t('STARTEDAT') + ' ' + tripTime(trip.timestamp)" placement="top"><i class="fa fa-2x" v-bind:class="[trip.Direction== 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                        <el-col :span="20" align="center">
                          <div class="el-progress el-progress--line el-progress--without-text" :class="[trip.Db_Date === null ? 'is-exception' : 'is-success']">
                            <div class="el-progress-bar">
                            <div class="el-progress-bar__outer" style="height: 18px;">
                              <div class="el-progress-bar__inner" v-if="trip.IsClosed!=1" v-bind:style="{ width: progressWidth(trip) + '%' }"></div>
                                <i v-if="trip.IsClosed!=1" class="fa fa-circle" v-bind:style="ballDirection(trip)"></i>
                                <div style="padding-top:2px" v-if="trip.IsClosed==1 "> {{$t('TRIPCLOSED')}}</div>
                                <div style="padding-top:2px" v-if="trip.Db_Date === null"> {{$t('EXPECTEDTOSTART')}} <span class="delayed pull-right">{{$t('DELAYEDBY') + ' ' + delayed_time(trip)}}</span></div>
                            </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="2" align="center"><el-tooltip :disabled="trip.Db_Date == null" effect="light" :content="trip.IsClosed == 1 ? ($t('CLOSEDAT') + ' ' + tripTime(trip.UpdatedAt)) : $t('NOTCLOSINGYET')" placement="top"><i  class="fa fa-2x" v-bind:class="[trip.Direction!= 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                      </el-row>
                      <el-row style="padding:0 10px" v-if ="showCost(trip)">
                        <el-col :span="8"><el-tooltip :content="$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TravelCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                        <el-col :span="8"><el-tooltip :content="$t('IDLECOST') +' ' + trip.IdleCost + ' ' + $t('AED')" position="bottom"><el-tag type="danger"><i class="fa fa-money"></i> {{trip.IdleCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                        <el-col :span="8"><el-tooltip :content="$t('TOTALCOST') +' ' + trip.TotalCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TotalCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                      </el-row>                      
                      </el-button>
                    </div>
                  </VuePerfectScrollbar>
                </el-col>
                <el-col :span="12" class="twocolumn">
                  <div v-if="listTrips['right'].length == 0" class="el-table__empty-block" style="width: 100%">
                    <span class="el-table__empty-text">{{$t('NOANYCLEANTRIPS')}}</span>
                  </div>                
                  <VuePerfectScrollbar ref="ScrollbarRight"  v-bind:style="{ height: listHeight + 'px' }">
                    <div>
                      <el-button v-if="is_live==!trip.IsClosed" @click="goTo(trip.TripID)"  type="text"  class="trip-box" :key="key" v-for="(trip,key) in listTrips['right']">
                      <el-row  v-if="cachedDates['right'][trip.Date]==trip.TripID" class="row date-header"><i class="el-icon-date"></i> {{tripDate(trip.Db_Date)}}</el-row >

                      <el-row style="padding:0 10px">
                        <el-col :span="4" class="busTag"><el-tag  type="primary"><i class="fa fa-bus"></i> {{trip.busNumber}} </el-tag></el-col>
                        <el-col :span="14" align="center"><i class="fa fa-road fa-2x"></i> {{trip.TourName}}</el-col>
                        <el-col :span="6" class="boardingTag">
                          <el-tag  type="primary"><i class="fa fa-user-circle"></i> <b  v-text="trip.Boarding"></b></el-tag>
                          <el-tag  type="primary" v-if="trip.IsClosed!=1"><i class="fa fa-map-marker"></i> {{nextStop(trip)}}</el-tag>
                          <el-tag  type="success" v-if="trip.IsClosed==1"><i class="fa fa-clock-o"></i> <b  v-text="trip.CompletedIn"></b> {{$t('MINUTES')}}</el-tag>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="2" align="center"><el-tooltip effect="light" :content="$t('STARTEDAT') + ' ' + tripTime(trip.timestamp)" placement="top"><i class="fa fa-2x" v-bind:class="[trip.Direction== 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                        <el-col :span="20" align="center">
                          <div class="el-progress el-progress--line el-progress--without-text" :class="[trip.Db_Date === null ? 'is-exception' : 'is-success']">
                            <div class="el-progress-bar">
                            <div class="el-progress-bar__outer" style="height: 18px;">
                              <div class="el-progress-bar__inner" v-if="trip.IsClosed!=1" v-bind:style="{ width: progressWidth(trip) + '%' }"></div>
                                <i v-if="trip.IsClosed!=1" class="fa fa-circle" v-bind:style="ballDirection(trip)"></i>
                                <div style="padding-top:2px" v-if="trip.IsClosed==1 "> {{$t('TRIPCLOSED')}}</div>
                            </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="2" align="center"><el-tooltip effect="light" :content="trip.IsClosed == 1 ? ($t('CLOSEDAT') + ' ' + tripTime(trip.UpdatedAt)) : $t('NOTCLOSINGYET')" placement="top"><i  class="fa fa-2x" v-bind:class="[trip.Direction!= 1 ? 'fa-home' : 'fa-university']"></i></el-tooltip></el-col>
                      </el-row>
                      <el-row style="padding:0 10px" v-if ="showCost(trip)">
                        <el-col :span="8"><el-tooltip :content="$t('FUELCOST') + ' ' + trip.TravelCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TravelCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                        <el-col :span="8"><el-tooltip :content="$t('IDLECOST') +' ' + trip.IdleCost + ' ' + $t('AED')" position="bottom"><el-tag type="danger"><i class="fa fa-money"></i> {{trip.IdleCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                        <el-col :span="8"><el-tooltip :content="$t('TOTALCOST') +' ' + trip.TotalCost + ' ' + $t('AED')" position="bottom"><el-tag><i class="fa fa-money"></i> {{trip.TotalCost + ' ' + $t('AED')}} </el-tag></el-tooltip></el-col>
                      </el-row>
                      </el-button>
                    </div>
                  </VuePerfectScrollbar>
                </el-col>
              </el-row>
            </div>
            <div style="padding:10px; border-top:1px solid #ddd" ref="pagination"  v-if="tab==1 && paginationHeight!=0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="limit"
                layout="total, sizes, prev, pager, next"
                :total="totalTrips"
                >
              </el-pagination>
            </div>     
        </el-row>
       </div>
    </el-card>
     <el-incident-dialog :incident="event" :alert="notifyAlert" :visible.sync="eventVisible"></el-incident-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import IncidentDialog from '@/components/dialogs/Incident'
  import _ from 'lodash'
  import { EventBus } from '../../event-bus.js'
  import qs from 'qs'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  export default {
    components: {VuePerfectScrollbar, 'el-incident-dialog': IncidentDialog},
    data () {
      return {
        infoOptions: {pixelOffset: {width: 0, height: -35}, padding: 0},
        trips: {},
        filtered_trips: {},
        routes: [],
        monitors: [],
        route: null,
        paths: {},
        filter: null,
        active_filter: 'date',
        date: [new Date(), new Date()],
        Direction: '',
        BusMonitorID: '',
        TourID: '',
        currentPage: 1,
        visitedPage: [1],
        loading: true,
        new_page: false,
        center: {},
        currentRow: null,
        listHeight: 0,
        mapHeight: 0,
        offset: 0,
        tab: 0,
        stops: {},
        maps: null,
        map: null,
        Polylines: {},
        bounds: {},
        live_trips: {},
        is_live: false,
        total: 0,
        routeColors: {},
        locations: {},
        MarkerWithLabel: null,
        totalTrips: 0,
        paginationHeight: 0,
        boarding: {},
        cachedDates: {},
        filtered: false,
        sendingEvent: null,
        lastFilter: '',
        prevIndex: 0,
        closedTripCount: 0,
        Limit: 0,
        pickerOption: {
          disabledDate (time) {
            return time.getTime() >= Date.now()
          }
        },
        notifyAlert: false,
        eventVisible: false,
        event: {},
        pageSizes: [50, 80, 100, 150, 200],
        students: {}
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
      this.mapHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.$el.offsetHeight + 54)
      this.listHeight = this.mapHeight
      let self = this
      this.$google.then(function (Maps) {
        self.maps = Maps
        self.map = new Maps.Map(document.getElementById('live-gmap'), {
          center: self.center,
          zoom: 14
        })
        let marker = new Maps.Marker({
          position: new Maps.LatLng(self.center),
          title: 'center',
          icon: require('../../assets/img/map/school.png')
        })
        marker.setMap(self.map)
        self.MarkerWithLabel = require('markerwithlabel')(Maps)
      })
      this.getMonitors()
      this.getRoutes()
      this.eventListener()
    },
    computed: {
      listTrips () {
        let trips = null
        if (this.is_live || this.filtered_trips[0] === undefined) trips = this.trips
        if (this.filtered && !this.filtered_trips[this.currentPage - 1]) trips = []
        if (!this.is_live && this.filtered_trips[this.currentPage - 1] !== undefined) trips = this.filtered_trips[this.currentPage - 1]
        let listTrips = {'left': [], 'right': []}
        if (_.isEmpty(trips)) return listTrips
        for (let trip in trips) {
          let TripID = parseInt(trip)
          if (trips[TripID] === undefined || (this.is_live && trips[TripID].IsClosed !== 0) || (!this.is_live && trips[TripID].IsClosed === 0)) continue
          if (trips[TripID].activity.total_alerts > 0 || trips[TripID].activity.total_violations > 0) listTrips['left'].push(trips[TripID])
          else listTrips['right'].push(trips[TripID])
        }
        return this.tripSort(listTrips)
      },
      limit: {
        get: function () {
          let limit = this.active_trips()
          limit = limit + (10 - (limit % 10))
          if (limit > this.pageSizes[0]) this.pageSizes = [limit, limit + 10, limit + 30, limit + 50, limit + 80]
          else limit = this.pageSizes[0]
          return (this.Limit > limit ? this.Limit : limit)
        },
        set: function (limit) {
          this.Limit = limit
        }
      },
      options () {
        let options = [{
          value: 'direction',
          label: this.$t('DIRECTION')
        }, {
          value: 'monitor',
          label: this.$t('SUPERVISOR')
        }, {
          value: 'date',
          label: this.$t('DATE')
        }]
        return options
      }
    },
    methods: {
      checkToday () {
        if (this.date === undefined) return false
        if (this.$moment(this.date[0]).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD') && this.$moment(this.date[1]).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD')) return false
        return true
      },
      active_trips () {
        return EventBus.trips.total
      },
      arrayOfAlerts (alerts) {
        var results = []
        for (let key in alerts) {
          results.push(alerts[key])
        }
        return results
      },
      tripDate (date) {
        return this.$moment(date).locale(localStorage.getItem('lang')).format('MMMM') + this.$moment(date).format(' DD, YYYY')
      },
      tripTime (time) {
        return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A')
      },
      showCost (trip) {
        if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true
        return false
      },
      delayed_time (trip) {
        let time = (trip.Direction === 1) ? trip.Time_AM_In : trip.Time_PM_In
        time = time.split(':')
        let display = ''
        let diff = this.$moment().subtract({hours: time[0], minutes: time[1]})
        if (diff.hour() > 0) display += diff.hour() + this.$tc('HOUR', (diff.hour() === 1 ? 1 : 2))
        if (diff.hour() > 0 && diff.minute() > 0) display += ','
        if (diff.minute() > 0) display += diff.minute() + this.$tc('MINUTE', (diff.minute() === 1 ? 1 : 2))
        this.$root.$children[0].TIME
        return display
      },
      activity_time (date) {
        return this.$moment(date).format('MM-DD-YYYY, h:mm a')
      },
      ballDirection (trip) {
        let direction = localStorage.getItem('lang') === 'en' ? 'left' : 'right'
        let css = {}
        let width = this.progressWidth(trip)
        if (width === 100) css[direction === 'left' ? 'right' : 'left'] = 0 + '%'
        else css[direction] = width + (width > 2 ? (trip.Boarding === 0 ? 0 : -0.8999) : 0) + '%'
        // css[direction] = (this.progressWidth(trip) - 0.8999) + '%'
        return css
      },
      btnGroup (val) {
        if (this.is_live === val) return
        this.is_live = val
        if (this.is_live && this.paginationHeight === 54) {
          this.listHeight += this.paginationHeight
          this.paginationHeight = 0
        }
        if (!this.is_live && this.paginationHeight === 0 && (this.filtered_trips[0] !== undefined || this.totalTrips > this.limit)) {
          this.paginationHeight = 54
          this.listHeight -= this.paginationHeight
        }
      },
      tripSort (trips_) {
        let sorted = {'left': [], 'right': []}
        this.cachedDates = {'left': {}, 'right': {}}
        let self = this
        if (trips_['left'].length !== 0) {
          let trips = trips_['left']
          Object.keys(trips).sort(function (a, b) {
            return trips[b].UpdatedAt - trips[a].UpdatedAt
          }).map(function (index) {
            if (trips[index].IsClosed === 1 && self.cachedDates['left'][trips[index].Date] === undefined) self.cachedDates['left'][trips[index].Date] = trips[index].TripID
            sorted['left'].push(trips[index])
          })
        }
        if (trips_['right'].length !== 0) {
          let trips = trips_['right']
          Object.keys(trips).sort(function (a, b) {
            return trips[b].UpdatedAt - trips[a].UpdatedAt
          }).map(function (index) {
            if (trips[index].IsClosed === 1 && self.cachedDates['right'][trips[index].Date] === undefined) self.cachedDates['right'][trips[index].Date] = trips[index].TripID
            sorted['right'].push(trips[index])
          })
        }
        return sorted
      },
      handleSizeChange (val) {
        this.limit = val
        this.trips = _.pick(this.trips, Object.values(this.live_trips))
        this.visitedPage = [1]
        this.loading = true
        this.getFilteredTrips()
      },
      activityInfo (obj, index) {
        this.notifyAlert = (obj.Event === 'ALERT')
        if (obj.data !== undefined) {
          this.event = obj.data
          this.eventVisible = true
          return
        }
        this.sendingEvent = obj.EventID
        let self = this
        this.eventResource(obj.EventID, this.notifyAlert).then(function (result) {
          self.sendingEvent = null
          let StudentID = result.data.student_id
          if (self.notifyAlert) {
            result.data.student_id = []
            result.data.student_id.push(StudentID)
          }
          self.event = obj.data = result.data
          self.eventVisible = true
        }).catch(function () { self.sendingEvent = null })
      },
      handleCurrentChange (val) {
        if (isNaN(val)) return
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getFilteredTrips()
      },
      liveTrips () {
        return Object.keys(this.live_trips).length
      },
      subscribeToLocation (trip) {
        let TripID = trip.TripID
        let id = TripID
        if (trip.IMEI !== null) id = trip.BusID
        this.$channel.bind('location-' + id, (data) => {
          if (this.trips[TripID] === undefined) return
          this.trips[TripID].location = this.trips[TripID].location.concat(data)
          let busLocation = data[data.length - 1]
          this.setBusLocation(busLocation)
        })
      },
      subscribeToBoarding (TripID) {
        this.$channel.bind('boarding-' + TripID, (boarding) => {
          EventBus.$emit('boarding', {TripID: TripID, data: boarding})
        })
      },
      eventListener () {
        EventBus.$on('trip', trip => {
          if (this.trips[trip.TripID] !== undefined) {
            this.total--
            let IsClosed = trip.IsClosed
            this.trips[trip.TripID].UpdatedAt = trip.UpdatedAt
            if (trip.timestamp !== undefined) this.trips[trip.TripID].timestamp = trip.timestamp
            if (trip.Expected) {
              this.trips[trip.TripID].Db_Date = (trip.Db_Date === undefined) ? null : trip.Db_Date
              this.trips[trip.TripID].BusDriverID = (trip.BusDriverID === undefined) ? null : trip.BusDriverID
              this.trips[trip.TripID].BusMonitorID = (trip.BusMonitorID === undefined) ? null : trip.BusMonitorID
            }
            let TourID = this.trips[trip.TripID].TourID
            this.$delete(this.live_trips, TourID)
            if (this.liveTrips() === 0) this.is_live = false
            if (trip.IsCancelled === 1) {
              if (trip.NewTripID !== undefined) {
                this.trips[trip.TripID].TripID = trip.NewTripID
                this.trips[trip.TripID].Boarding = 0
                this.trips[trip.TripID].checked_stop = 0
                this.assignNewTrip(this.trips[trip.TripID])
                this.$delete(this.stops, trip.TripID)
              }
              this.$delete(this.trips, trip.TripID)
            } else {
              if (trip.TotalCost !== undefined) {
                this.trips[trip.TripID].TotalCost = trip.TotalCost
                this.trips[trip.TripID].TravelCost = trip.TravelCost
                this.trips[trip.TripID].VehicleCost = trip.TotalCost
                this.trips[trip.TripID].IdleCost = trip.IdleCost
              }
              this.trips[trip.TripID].CompletedIn = trip.CompletedIn
              this.trips[trip.TripID].IsClosed = IsClosed
            }
            if (trip.IsClosed === 1 && this.filtered_trips[this.currentPage - 1][trip.TripID] === undefined) this.$set(this.filtered_trips[this.currentPage - 1], trip.TripID, this.trips[trip.TripID])
            if (this.locations[trip.TripID] !== undefined) {
              this.locations[trip.TripID].setMap(null)
              this.$delete(this.locations, trip.TripID)
            }
            return
          }
          this.total++
          this.assignNewTrip(trip)
        })
        EventBus.$on('incident', incident => {
          if (this.trips[incident.TripID] === undefined) return
          this.trips[incident.TripID].UpdatedAt = this.$moment().unix()
          let obj = {}
          obj.Event = 'INCIDENT'
          obj.EntityID = null
          obj.EventID = incident.incident_id
          obj.EventType = incident.incident_type
          obj.Sent = incident.Timestamp
          obj.Text = incident.Text
          if (this.trips[incident.TripID].activity.alerts[incident.incident_id] === undefined) {
            this.trips[incident.TripID].activity.alerts[incident.incident_id] = obj
            this.trips[incident.TripID].activity.total_alerts++
          }
        })
        EventBus.$on('alert', alert => {
          if (this.trips[alert.TripID] === undefined) return
          this.trips[alert.TripID].UpdatedAt = this.$moment().unix()
          if (this.trips[alert.TripID].activity.alerts[alert.EventID] === undefined) {
            this.trips[alert.TripID].activity.alerts[alert.EventID] = alert
            this.trips[alert.TripID].activity.total_alerts++
          }
        })
        EventBus.$on('boarding', boarding => {
          let TripID = boarding.TripID
          let _bording = Object.assign({}, boarding.data)
          if (_bording.IsMissing !== undefined) return
          if (_bording.CheckOut === undefined) this.trips[TripID].Boarding = _bording.Boarding
          if (_bording.CheckOut !== undefined) this.trips[TripID].checked_out = _bording.CheckOut
          if (this.trips[TripID].Direction === 1 && _bording.CheckOut !== undefined) _bording.Stop = this.trips[TripID].student_stops
          this.trips[TripID].checked_stop = parseInt(_bording.Stop)
        })
      },
      isLive (route) {
        let TourID = parseInt(route.TourID)
        let TripID = this.live_trips[TourID]
        if (TripID !== undefined && this.trips[TripID].Date !== null) return true
        return false
      },
      assignNewTrip (trip) {
        let obj = {}
        obj[trip.TripID] = trip
        this.trips = Object.assign(obj, this.trips)
        this.live_trips[trip.TourID] = trip.TripID
        this.stopsPoint(trip)
      },
      selectAll () {
        if (Object.keys(this.paths).length === Object.keys(this.live_trips).length) return true
        return false
      },
      getTrips () {
        let self = this
        let limit = self.limit
        if (limit < this.active_trips()) limit = this.active_trips()
        this.todayClosedTrips().then(function (coloedTrips) {
          if (coloedTrips.data.total !== undefined) {
            self.closedTripCount = parseInt(coloedTrips.data.total)
            limit += self.closedTripCount
          }
          self.$http.get('/trip?limit=' + limit + '&offset=' + self.offset)
            .then(function (response) {
              self.loading = false
              if (response.data.total === undefined) return
              self.tab = 1
              let trips = response.data.trips
              for (let trip in trips) {
                self.$set(self.trips, trip, trips[trip])
                if (trips[trip].IsClosed === 0) {
                  self.is_live = true
                  self.live_trips[trips[trip].TourID] = trip
                  response.data.total--
                  self.subscribeToLocation(trips[trip])
                  self.subscribeToBoarding(trip)
                  self.setBusLocation(trips[trip])
                  self.stopsPoint(trips[trip])
                }
              }
              let closedTrips = _.omit(self.trips, Object.values(self.live_trips))
              Vue.set(self.filtered_trips, self.currentPage - 1, closedTrips)
              self.totalTrips = self.total = response.data.total
              if (!self.is_live && self.paginationHeight === 0 && (self.filtered_trips[0] !== undefined || self.totalTrips > self.limit)) {
                self.paginationHeight = 54
                self.listHeight -= self.paginationHeight
              }
              self.lastFilter = qs.stringify(self.bindCurrentFilters())
            })
            .catch(function (error) {
              console.log(error)
            })
        }).catch(function (error) {
          console.log(error)
        })
      },
      getFilteredTrips (val) {
        if (val !== undefined) {
          if (this.date === undefined) val = null
          if (this.date !== undefined && this.date[0] === null && this.date[1] === null) val = null
          if (_.isEmpty(val)) this.clearFilter()
        }
        this.filtered = this.loading = true
        let self = this
        if (self.isFilterChanged()) {
          self.currentPage = 1
          self.visitedPage = [1]
        }
        this.$http.get('/trip?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1))
          .then(function (response) {
            if (self.paginationHeight === 0) {
              self.paginationHeight = 54
              self.listHeight -= self.paginationHeight
            }
            self.new_page = self.loading = false
            // Still we need to controll the count to each page, currently per page count is wrong...
            let closedTrips = _.omit(response.data.trips, Object.values(self.live_trips))
            Vue.set(self.filtered_trips, self.currentPage - 1, closedTrips)
            if (self.active_filter === 'date') {
              if (self.date[0].toDateString() === new Date().toDateString() && self.date[1].toDateString() === new Date().toDateString()) {
                for (let trip in response.data.trips) {
                  if (response.data.trips[trip].IsClosed === 0) response.data.total--
                }
              }
            }
            self.totalTrips = (!self.isFilterChanged()) ? self.totalTrips : response.data.total
            self.lastFilter = qs.stringify(self.bindCurrentFilters())
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      isFilterChanged () {
        if (this.lastFilter === qs.stringify(this.bindCurrentFilters())) return false
        return true
      },
      getRoutes () {
        let self = this
        this.$http.get('/route?minimized')
          .then(function (response) {
            self.routes = response.data
            for (let route in self.routes) {
              self.routeColors[self.routes[route].TourID] = self.routes[route].RouteColor
            }
          })
          .catch(function (error) {
            console.log(error)
          }).then(function () {
            self.getTrips()
          })
      },
      getMonitors () {
        let self = this
        if (!_.isEmpty(self.monitors)) return
        this.$http.get('/supervisor')
          .then(function (response) {
            self.monitors = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      bindCurrentFilters () {
        let data = {filters: {}}
        switch (this.active_filter) {
          case 'direction':
            if (this.Direction !== '') data.filters.Direction = this.Direction
            break
          case 'tour':
            if (this.TourID !== '') data.filters.TourID = this.TourID
            break
          case 'monitor':
            if (this.BusMonitorID !== '') data.filters.BusMonitorID = this.BusMonitorID
            break
          case 'date':
            if (_.isNull(this.date[0]) && _.isNull(this.date[1])) break
            data.filters.Date = {}
            data.filters.Date.min = this.$moment(this.date[0]).format('YYYY-MM-DD')
            data.filters.Date.max = this.$moment(this.date[1]).format('YYYY-MM-DD')
            break
        }
        return data
      },
      goTo (TripID) {
        this.$router.push({path: '/report/trip/' + TripID})
      },
      progressWidth (trip) {
        let stop = trip.checked_stop
        if (trip.skip_stops < stop) stop -= trip.skip_stops
        if (stop === 0 || trip.IsClosed === 1) return 0
        if (trip.Direction === 2 && trip.checked_out == null) return 0
        if (trip.Direction === 1 && trip.checked_out !== null) stop = trip.student_stops + 1
        return this.stops[trip.TripID].sizes[stop - 1]
      },
      nextStop (trip) {
        let num = 1
        let stop = trip.checked_stop
        if (trip.skip_stops < stop) stop -= trip.skip_stops
        if (trip.Direction === 2 && trip.checked_out !== null) num = 0
        if (stop === 0 || (trip.Direction === 2 && trip.checked_out === null)) return this.$t('FIRSTSTOP')
        if (trip.Direction === 1 && trip.checked_out !== null) return this.$t('SCHOOL')
        if (stop !== this.stops[trip.TripID].sizes.length - num) return this.$t('NEXTSTOP') + ' ' + (stop + 1)
        if (stop === this.stops[trip.TripID].sizes.length) return this.$t('LASTSTOP')
        return trip.Direction === 1 && this.trips[trip.TripID].checked_out !== null ? this.$t('SCHOOL') : this.$t('NOMORESTOPS')
      },
      stopsPoint (trip) {
        if (this.stops[trip.TripID] !== undefined) return
        let points = []
        let distance = 0
        let percentage = null
        if (trip.IsClosed === 1) return 0
        let stops = trip.stops
        for (let stop in stops) {
          distance += parseInt(stops[stop].Distance)
          points.push(distance)
        }
        distance = parseFloat(distance / 1000).toFixed(2)
        if (trip.Direction === 1) distance *= 2
        let sizes = []
        for (let item in points) {
          let value = parseFloat(points[item] / 1000).toFixed(2)
          percentage = (value * 100) / distance
          sizes.push(percentage)
        }
        if (trip.Direction === 1) sizes.push(100)
        this.stops[trip.TripID] = {sizes: sizes, checked_stop: trip.checked_stop, Direction: trip.Direction}
      },
      reBound (route) {
        this.setPulseLocation(route)
        if (Object.keys(this.paths).length === 0) return
        this.bounds = new this.maps.LatLngBounds()
        for (let path in this.paths) {
          let paths = this.paths[path]
          for (let _path in paths) {
            this.bounds.extend(paths[_path])
          }
        }
        this.map.fitBounds(this.bounds)
      },
      setBusLocation (trip) {
        if (trip.location.length === 0) return
        trip = this.trips[trip.TripID]
        let location = trip.location[trip.location.length - 1]
        let position = new this.maps.LatLng(parseFloat(location.Lat), parseFloat(location.Lng))
        this.setPulseLocation(trip.TourID)
        if (typeof this.locations[trip.TripID] === 'object') this.locations[trip.TripID].setPosition(position)
      },
      setPulseLocation (route) {
        if (this.live_trips[route] === undefined) return
        let trip = this.trips[this.live_trips[route]]
        if (trip.location.length === 0) return
        if (this.locations[trip.TripID] === undefined) this.locations[trip.TripID] = new this.MarkerWithLabel({map: this.map})
        let color = this.routeColors[route]
        let labelStyle = null
        let labelClass = 'bus fa fa-bus fa-3x'
        let poins = [14, 42]
        let icon = {path: 'M22-48h-44v43h16l6 5 6-5h16z', fillColor: color, fillOpacity: 1, strokeColor: color}
        if (this.paths[route] !== undefined) {
          icon = {path: this.maps.SymbolPath.CIRCLE}
          poins = [15, 15]
          labelStyle = {background: color, borderColor: color}
          labelClass = 'pulse'
        }
        let labelAnchor = new this.maps.Point(poins[0], poins[1])
        this.locations[trip.TripID].setIcon(icon)
        this.locations[trip.TripID].set('labelClass', labelClass)
        this.locations[trip.TripID].set('labelAnchor', labelAnchor)
        this.locations[trip.TripID].set('labelStyle', labelStyle)
      },
      toggleCheck () {
        for (let key in this.routes) {
          if (this.isLive(this.routes[key])) this.routeChange(key)
        }
      },
      routeChange (val) {
        if (val === -1) return this.toggleCheck()
        if (this.routes[val] === undefined) return
        let route = this.routes[val]
        if (this.routes !== undefined && this.route !== null) this.route = route.TourName
        if (this.paths[route.TourID] !== undefined) {
          delete this.paths[route.TourID]
          if (Object.keys(this.paths).length === 0) this.route = null
          this.Polylines[route.TourID].setMap(null)
          this.reBound(route.TourID)
          return
        }
        /* eslint new-cap: ["error", { "newIsCap": false }] */
        let TripID = this.live_trips[route.TourID]
        let direction = this.trips[TripID].Direction
        let path = route.path[2 - direction]
        this.paths[route.TourID] = new this.maps.geometry.encoding.decodePath(path)
        this.Polylines[route.TourID] = new this.maps.Polyline({
          path: this.paths[route.TourID],
          strokeColor: route.RouteColor,
          strokeOpacity: 1.0,
          strokeWeight: 5
        })
        this.Polylines[route.TourID].setMap(this.map)
        this.reBound(route.TourID)
      },
      clearFilter () {
        this.filtered = false
        this.active_filter = 'date'
        this.date = [new Date(), new Date()]
        this.filtered_trips = {}
        this.listHeight += this.paginationHeight
        this.paginationHeight = 0
      },
      changedFilter (val) {
        if (val !== null) this.active_filter = val
        this.filter = null
        let load = false
        if (this.Direction !== '' || this.BusMonitorID !== '' || this.TourID !== '') load = true
        if (load) {
          this.Direction = this.BusMonitorID = this.TourID = ''
          this.listHeight += this.paginationHeight
          this.paginationHeight = 0
        }
      },
      eventResource (EventID, alert) {
        return this.$http.get('/incident/event_info?EventID=' + EventID + '&IsAlert=' + alert)
      },
      todayClosedTrips () {
        return this.$http.get('trip?filters%5BDate%5D%5Bmin%5D=' + this.$moment(new Date()).format('YYYY-MM-DD') + '&filters%5BDate%5D%5Bmax%5D=' + this.$moment(new Date()).format('YYYY-MM-DD') + '&limit=1&offset=0')
      }
    }
  }
</script>

<style>
.pin {
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  background: #00cae9;
  position: absolute;
  transform: rotate(-45deg);
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.pin:after {
  content: "";
  width: 14px;
  height: 14px;
  margin: 8px 0 0 8px;
  background: #e6e6e6;
  position: absolute;
  border-radius: 50%;
}

.bounce {
  animation-name: bounce;
  animation-fill-mode: both;
  animation-duration: 1s;
}
.route-select.hover:first-child{background:none}
.filters .el-badge{margin-top:0; float:right; margin-right:10px}
.filters .el-badge .is-fixed{z-index:999}
.date-header {
    padding: 10px;
    margin-top: -10px;
    margin-bottom: 10px;
    background: #f4dd93;
    color: #4b4b4b;
    text-align: center;
    font-weight: bold;
}
.live-trip-btn{float:right}
#rtl .live-trip-btn{float:left}
#rtl .filters .el-badge {float:left; margin-left:10px; margin-right:0}
.activity .el-badge i{font-size: 14px;}
.activity .el-badge{margin-top: 0px;margin-right: 15px;}
#rtl .activity .el-badge{margin-top: 0px;margin-right: 15px;}
.el-popover.trip {padding: 0px;padding-top:10px}
.el-popover.trip  .el-popover__title{padding-left: 5px;}
#rtl .el-popover.trip  .el-popover__title{padding-right: 5px;}
.el-popover.trip .el-table{min-height: 80px;}
#trip .el-table__expanded-cell{padding:8px 28px;}
.delayed {
  display: inline-block;
  margin-top: -2px;
  padding: 0 5px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
  color: #f7ba2a;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid transparent;
  white-space: nowrap;  
}
.twocolumn:first-child{height: inherit;border-right: 1px solid rgb(204, 204, 204);}
#rtl .twocolumn:first-child{height: inherit;border-left: 1px solid rgb(204, 204, 204); border-right:0}
</style>



// WEBPACK FOOTER //
// Trip.vue?3d204be5